import {
  BookkeepersManagementTaskDocumentsDocument,
  BookkeepersManagementTaskDocumentsQuery,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

import { useBookkeeperView } from 'modules/bookkeepers/lib/bookkeeperViewContext'

export type IncidenceTaskDocumentsQueryData =
  BookkeepersManagementTaskDocumentsQuery['bookkeepersManagement']['taskDocumentsConnection']['nodes']

export type IncidenceTaskDocument = IncidenceTaskDocumentsQueryData[number]

const useGetIncidenceTaskDocuments = ({ incidenceId }: { incidenceId: number }) => {
  const isBookkeeperView = useBookkeeperView()
  const { data, loading, refetch } = useQuery(BookkeepersManagementTaskDocumentsDocument, {
    variables: {
      incidenceId,
    },
    context: {
      isBookkeeperView,
    },
  })

  return {
    loading,
    refetch,
    taskDocuments: data?.bookkeepersManagement.taskDocumentsConnection.nodes || [],
  }
}

export default useGetIncidenceTaskDocuments
